import { createAction, props } from '@ngrx/store';
export const setGeneratingReport = createAction('[Custom PDF Report Modal] Set Generating Report');
export const setNotGeneratingReport = createAction('[Custom PDF Report Modal] Set Not Generating Report');
export const setGeneratingUnsavedReport = createAction('[Custom PDF Report Modal] Set Generating Unsaved Report', props());
export const setNotGeneratingUnsavedReport = createAction('[Custom PDF Report Modal] Set Not Generating Unsaved Report');
export const addGenerationError = createAction('[Custom PDF Report Modal] Add Generation Error', props());
